import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {SelectFieldOptionsService} from '../../services/select-field-options-service.service';
import {DynFillableTextField} from "../../domain/meta/fields/dyn-fillable-text-field";
import {DynField} from "../../domain/meta/dyn-field";
import {AbstractControl, FormControl} from "@angular/forms";

@Component({
    selector: 'app-fillable-text-field',
    templateUrl: './fillable-text-field.component.html',
    styleUrls: ['./fillable-text-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FillableTextFieldComponent implements OnInit {

    @Input() control: AbstractControl;
    @ViewChild('editableField') editableField: ElementRef;
    focused = false;
    pristine = true;
    invalid = false;
    defaultText = "campo a completar";
    empty = true;

    constructor(private cd: ChangeDetectorRef) {
    }


    ngOnInit() {
        this.control.setValue(this.defaultText);
        this.cd.markForCheck();

    }

    onFocus() {
        setTimeout(() => {
            this.focused = true;
            this.pristine = false;
            if(this.control.value === this.defaultText){
                this.control.setValue("");
            }
            this.cd.markForCheck();
        },0)
    }

    onFocusOut() {
        this.focused = false;
        this.control.setValue(this.getFormattedValue());
        if(this.control.value.length === 0)
            this.empty = true;
        this.invalid = this.control.value === this.defaultText;
        this.cd.markForCheck()
    }

    getFormattedValue() {
        return this.editableField.nativeElement.innerHTML.toString().replace(/&nbsp;/g, " ");
    }

    checkValueAfterEmpty(){
        this.empty = this.getFormattedValue() === 0;
    }

    /* evita copiar html y otros tags de formato cuando el texto es de un pagina web o Word */
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const text = event.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
    }

}



// WEBPACK FOOTER //
// ./src/app/forms/components/form-data-fillable-text-field/fillable-text-field.component.ts